// Mirrors unpaqd-frontend's src/library/utils/zohoConfig.ts (same widget, same account) —
// ported here because customer-fe (where the pricing page/Host Pro purchase lives) had zero
// Zoho payment plumbing before this. CRA env vars use the REACT_APP_ prefix instead of
// NEXT_PUBLIC_; QA detection mirrors the hostname check already used in
// library/constants/api.js's getApiBaseUri().

export interface ZohoConfig {
  account_id: string;
  api_key: string;
  domain: string;
  is_test_mode: boolean;
}

function isQaOrLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname.includes('qa') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  );
}

export const getZohoConfig = (): ZohoConfig => {
  const account_id = process.env.REACT_APP_ZOHO_ACCOUNT_ID || '';
  const domain = process.env.REACT_APP_ZOHO_DOMAIN || 'IN';
  let api_key = process.env.REACT_APP_ZOHO_API_KEY || '';
  let is_test_mode = false;

  if (isQaOrLocalhost()) {
    const qaApiKey = process.env.REACT_APP_ZOHO_QA_API_KEY;
    if (qaApiKey) {
      api_key = qaApiKey;
    }
    is_test_mode = true;
  }

  return { account_id, api_key, domain, is_test_mode };
};
